import React from 'react'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Tooltip from 'components_new/atoms/Tooltip'

import Caption from 'components_new/molecules/Node/Caption'
import { BOARD, getAccent } from 'components_new/molecules/Node/accents'

import NodeType from 'types/transformation/enums/NodeType'

import { NODE_CATALOG } from '../Node/catalog'

interface NodePaletteProps {
  onSelect: (type: NodeType) => void
}

/**
 * Left rail listing the node types a user can add, grouped by category.
 * Clicking an item adds that node to the board. Shown only in edit mode.
 */
const NodePalette = (props: NodePaletteProps) => {
  const { onSelect } = props

  return (
    <Box
      sx={{
        backgroundColor: '#FBFBFC',
        borderRight: `1px solid ${BOARD.borderSoft}`,
        display: 'flex',
        flex: 'none',
        flexDirection: 'column',
        gap: 2,
        overflowY: 'auto',
        px: 1.5,
        py: 1.75,
        width: 168
      }}
    >
      {NODE_CATALOG.map((section) => (
        <Box
          key={section.group}
          sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}
        >
          <Caption>{section.group}</Caption>
          {[...section.items]
            .sort((a, b) => a.title.localeCompare(b.title, 'sv'))
            .map((item) => {
              const accent = getAccent(item.type)

              return (
                <Tooltip key={item.type} title={item.description}>
                  <Box
                    onClick={() => onSelect(item.type)}
                    sx={{
                      alignItems: 'center',
                      backgroundColor: 'common.white',
                      border: '1px solid #EDEDF0',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      display: 'flex',
                      gap: 1,
                      px: 1,
                      py: 0.75,
                      transition: 'box-shadow 0.15s, border-color 0.15s',
                      '&:hover': {
                        borderColor: BOARD.border,
                        boxShadow: BOARD.shadowRest
                      }
                    }}
                  >
                    <Box
                      sx={{
                        alignItems: 'center',
                        backgroundColor: accent.bg,
                        borderRadius: '7px',
                        color: accent.stark,
                        display: 'flex',
                        flex: 'none',
                        height: 22,
                        justifyContent: 'center',
                        width: 22
                      }}
                    >
                      <Icon name={item.icon} sx={{ fontSize: '14px' }} />
                    </Box>
                    <Box
                      sx={{
                        color: BOARD.textPrimary,
                        fontFamily: BOARD.fontDisplay,
                        fontSize: '12px',
                        fontWeight: 600,
                        minWidth: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {item.title}
                    </Box>
                  </Box>
                </Tooltip>
              )
            })}
        </Box>
      ))}
    </Box>
  )
}

export default NodePalette
